import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import './login.css'
import Textfield from '@atlaskit/textfield';
import FormControl from '@mui/material/FormControl';
import { Box, Button, Container, Grid, Link, TextField, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Diversity1 } from '@mui/icons-material';
import {setUserSession,getToken,setSessionId,getMachineDetails,removeUserSession, getUser} from '../util'
import { Navigate } from "react-router-dom"
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from '@atlaskit/modal-dialog';
import Navbar from '../navbar/navbar'
import Fab from '@mui/material/Fab';
import NavigationIcon from '@mui/icons-material/Navigation';
import LinearProgress from '@mui/material/LinearProgress';
import queryString from "query-string"
import InputOutlinedIcon from '@mui/icons-material/InputOutlined';
import Logo from '../../components/adminDashboard/images/logo.png'
import Image from 'mui-image'
import QRCode from "qrcode.react";
import WestIcon from '@mui/icons-material/West';
export default class Login extends React.Component{
  partymail
  constructor(props){
    super(props)
    this.state={
      email:'',
      password:'',
      modelOpen:false,
      redirect:false,
      directadmin:false,
      customerChecked:true,
      directcustomer:false,
      progress:false,
      modelOpen1:false,
      model1:false,
      errorMsg:'',
      intervalId:'',
      redBox:false,
      style : {
        position: 'absolute',
        height:'80%',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1000,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
      },
    }
  }  
  componentDidMount=()=>{
    const queryParams = queryString.parse(window.location.search)
    if(queryParams.auth==='1'){
      this.setState({modelOpen1:true})
    }
  }
  modelOpen1Close=()=>{
    this.setState({modelOpen1:false,})
  }
  viewPage=()=>{
    this.setState({directcustomer:true})
  } 
  onModelClick=()=>{
    this.setState({modelOpen:true})
  }
  onModelCose=()=>{
    this.setState({modelOpen:false,progress:false}) 
  }
  validateEmail=(email)=> {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  onLoginSave=()=>{
    if(this.state.email===''||this.state.password===''){
      alert('All Inputs Are Required')
    }else if(!this.validateEmail(this.state.email)){
      alert('Please Enter Valid MailId')
    }
    else{
      this.setState({progress:true})
      let json_data={emailId:this.state.email,password:this.state.password,logoutdatetime:null}
      fetch(`eadmin/v1/set/user_login`, {
      method: 'POST',
      headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      },
      body:(JSON.stringify(json_data)),
      }).then((response) => response.json())
      .then((responseJson) => {
        if(!responseJson.status){
          this.setState({progress:false,errorMsg:'Email or Password Incorrect'})
        }
        else if(responseJson.emailVerified){
          this.setState({progress:false})
          setUserSession(responseJson.token, responseJson.result[0]);
          setSessionId(responseJson.sessionId)
          localStorage.setItem('login','customer')
          this.setState({redirect:true})
        }else if(!responseJson.emailVerified){
          this.onModelClick()
        }else{
          this.setState({progress:false,})
          alert(responseJson.errorMsg)
        }
      }).catch((error) => {
        alert(error)
      });
    }
  } 
  OnMailLink=()=>{
    this.setState({modelOpen:false,progress:false,email:'',password:''})
    let json_data={emailId:this.state.email}
    fetch(`eadmin/v1/set/send_activate_link`, {
    method: 'POST',
    headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    },
    body:(JSON.stringify(json_data)),
    }).then((response) => response.json())
    .then((responseJson) => {
      if(responseJson.status ){
        alert('Please Check The Mail To Verify The Link')
        this.setState({email:'',password:'',progress:false})
      } 
      else{
        this.setState({progress:false})
        alert(responseJson.errorMsg)
      }
    }).catch((error) => {
      alert(error)
    });
  }
  mobie_login=()=>{
    if(this.state.email===''){
      alert('Email Id required')
    }else{
        //setLoading(true)
        fetch(`http://103.96.96.57:3000/eadmin/v1/set/save_authentication`, {
          method: 'POST',
          headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          "x-access-inkey":"OQ3AIXGXS0Q0FDZ1SP8T"
          },
          body: JSON.stringify({emailId:this.state.email,employeeId:12,deviceName:getMachineDetails().name}),
        }).then((response) => response.json())
        .then((responseJson) => {
          alert(JSON.stringify(responseJson))
            if(responseJson.status){
              alert('Request Send Your Mobile')
              this.setState({model1:true})
              this.state.intervalId=setInterval(() => {
                this.check_mobile_login(responseJson.result[0].authid)
              }, 3000)
              setTimeout(() => {
                //setLoading(false)
                clearInterval(this.state.intervalId)
              }, 1000*20);
            }else{
              //setLoading(false)
              removeUserSession();
            }
        }).catch((error) => {
          //setLoading(false)
        });
    }
  }
   check_mobile_login=(authid)=>{
      fetch(`http://103.96.96.57:3000/eadmin/v1/set/get_auth_details?authId=${authid}`, {
        method: 'GET',
        headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        "x-access-inkey":"OQ3AIXGXS0Q0FDZ1SP8T"
        },
      }).then((response) => response.json())
      .then((responseJson) => {
          if(responseJson.status){
            if(responseJson.emailVerified){
              //setLoading(false) 
              setUserSession(responseJson.token, responseJson.result);
            }
          }else if(responseJson.auth){
            removeUserSession();
           // setLoading(false)
            clearInterval(this.state.intervalId)
          }
      }).catch((error) => {
        //setLoading(false)
        alert(error)
      });
  }
  forgetClick=()=>{
      if(this.state.email!==''){
        
        let data={mail:this.state.email}
        
        localStorage.setItem('party_mail',JSON.stringify(data))
    
      }
  }
  
  render(){
    return(
    <>
      <Navbar customer={false} buttonClick={this.viewPage}/> <br/><br/><br/>
      <div class="login-wrap">
        {this.state.progress && <LinearProgress color="secondary"/>}
        <div class="login-html" >
          {this.props.admin?true:false}
          <input id="tab-1" type="radio" name="tab" class="sign-in"defaultChecked /><label for="tab-1" class="tab">Customer LogIn </label>
          <input id="tab-2" type="radio" name="tab" class="sign-up"  /><label for="tab-2" class="tab"> </label>
          <div class="login-form">
            <div class="sign-in-htm">
              <div class="group">
                  <FormControl sx={{ m:1, width: '95%' }}>
                    <Textfield InputLabelProps={{style:{color:'black',opacity:'0.5'}}}  placeholder="Emailid" aria-label="default text field" label="Email Id *"  error={this.state.errorMsg=== "Email or Password Incorrect"  } style={{fontWeight:'600',backgroundColor:"white"}} value={this.state.email} onChange={(evt)=>this.setState({email:evt.target.value})
               }/>
                  </FormControl>
              </div>
              <div class="group">
                <pre>
                  <FormControl sx={{ m:1, width: '95%' }}>
                    <Textfield  InputLabelProps={{style:{color:'black',opacity:'0.5'}}} placeholder="Password" aria-label="default text field" label="Password *" type="password" error={this.state.errorMsg=== "Email or Password Incorrect"  } value={this.state.password} style={{fontWeight:'600',backgroundColor:"white"}}  onChange={(evt)=>this.setState({password:evt.target.value})}/>
                    <br/>
                  {this.state.errorMsg === '' ? null :
                  <span style={{
                    fontWeight: 'bold',
                    color: 'red',
                  }}>{this.state.errorMsg}</span>}
                  </FormControl>
                </pre>
              </div>
              <div class="group">
                <a href="/forgetpassword" onClick={this.forgetClick} style={{color:'white',paddingLeft:'60%'}}>Forgot Password?</a>
              </div>
              <div class="group">
              <input type="submit" class="button" value="LogIn" onClick={this.onLoginSave}/>
              </div><br/>
              <div class="group">
                <center><span style={{color:'white',paddingLeft:'10px',opacity:'0.5'}}>or</span></center>
              </div>
              <div class="group">
                <center><Fab variant="extended" onClick={this.mobie_login}><InputOutlinedIcon sx={{ mr: 1 }}  color="secondary"/> Push Notification</Fab></center>
              </div>
              <div class="hr"></div>
              <div class="foot-lnk">
                <a href="/register" style={{color:'white',paddingLeft:'10px'}}>Don't have an account?<Button appearance="primary" style={{color:"white",background:"#1161ee" ,borderRadius:'5px',paddingRight:'2%'}}>Create</Button></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalTransition>
        {this.state.modelOpen && (
          <Modal onClose={this.onModelCose} >
            <ModalHeader>
              <ModalTitle>LogIn</ModalTitle>
            </ModalHeader>
            <ModalBody>
              <label>Do You Want To ReSend the Activate link </label>
            </ModalBody>
            <ModalFooter>
              <Button appearance="primary" onClick={this.OnMailLink} autoFocus>
                OK
              </Button>
              <Button appearance="primary" onClick={this.onModelCose} autoFocus>
                cancel
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </ModalTransition>
      <ModalTransition>
        {this.state.modelOpen1 && (
          <Modal onClose={this.modelOpen1Close} >
            <ModalHeader>
              <ModalTitle>LogIn</ModalTitle>
            </ModalHeader>
            <ModalBody>
              <label>Verified SuccessFully</label>
            </ModalBody>
            <ModalFooter>
              <Button appearance="primary" onClick={this.modelOpen1Close} autoFocus>
                OK
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </ModalTransition>
      <ModalTransition>
      {this.state.model1 && (
      <Modal>
       <Box sx={ this.state.style}>
          <Grid container spacing={2}>
            <Grid item  style={{  width: '650%' }} xs={12} md={12} sm={12}>
              <Box  p={1} style={{width:'100%'}}>
                <div className="greyBox" style={{width:'95%'}}>
                  <div className="row">
                    <div className="col-sm-11">
                      <h5 style={{paddingLeft:'1%'}} className="lato-font"> SA AUTHENTICATION</h5>
                    </div>
                    <div className="col-sm-1" >
                      {/*<CloseSharpIcon onClick={this.onModalCloseButton} style={{height: '80%', width:'80%', borderRadius: 25,backgroundColor:'white'  }} />*/}
                    </div>
                  </div>
                </div>
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={5}>
            <Grid item md={5}>
              <Image src={Logo} style={{height:'65%'}}/>
            </Grid>
            <Grid item md={7}>
              <Grid container spacing={5}>
                <Grid item md={1.5}>
                  <label style={{paddingTop:'18px',fontSize:'20px'}}>Device</label>
                </Grid>
                <Grid item md={10}>
                  <FormControl sx={{ m:1, width: '95%' }}>
                    <Textfield aria-label="default text field"/>
                  </FormControl>
                </Grid>
                <Grid item md={12}>
                  <label style={{fontSize:'20px'}}>Choose an authentication method</label>
                </Grid>
                <Grid md={3}>
                    <Image style={{paddingTop:"5%"}} src="https://media.istockphoto.com/photos/mobile-phone-top-view-with-white-screen-picture-id1161116588?k=20&m=1161116588&s=612x612&w=0&h=NKv_O5xQecCHZic53onobxjqGfW7I-D-tBrzXaPbj_Q="/>
                </Grid>
                <Grid item md={6}>
                <Fab variant="extended" color='white'>
                   Send Notification to your Phone
                </Fab>
                  {/*<label style={{paddingTop:'25px'}}>SA Push</label>*/}
                </Grid>
                <Grid item md={2}>
                  {/*<FormControl sx={{ m:1, width: '95%' }}>
                    <Button variant="contained">Send Push</Button>
                  </FormControl>*/}
                </Grid>
                <Grid item md={3}>
                  <QRCode value="https://www.google.com/"style={{ marginRight: 50 }}/>
                </Grid>
                <Grid item md={6}>
                <FormControl sx={{ m:3, width: '95%' }}>
                <Fab variant="extended">
                   You Can Scan Here
                </Fab>
                </FormControl>
                  {/*<label style={{paddingTop:'15px'}}>SA Scan</label>*/}
                </Grid>
                <Grid item md={2}>
                 {/*<FormControl sx={{ m:1, width: '95%' }}>
                    <Button variant="contained">Scan</Button>
                  </FormControl>*/}
                </Grid>
                <Grid item md={3}>
                  <label style={{paddingTop:'18px'}}>Passcode</label>
                </Grid>
                <Grid item md={3}>
                  <FormControl sx={{ m:1, width: '95%' }}>
                    <Textfield aria-label="default text field"/>
                  </FormControl>
                </Grid>
                <Grid item md={6}>
                  <FormControl sx={{ m:1, width: '95%' }}>
                    <Button variant="contained">Submit</Button>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <br/>
        </Box>
      </Modal>
      )}
  </ModalTransition>
      { 
        this.state.redirect && <Navigate to='/subscription' replace={true}/>
      }
      { 
        this.state.directcustomer && <Navigate to='/adminlogin' replace={true}/>
      }
	  </>
    )
  }
}